import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './PerformanceTable.css';


class DrawdownRow extends Component {

    formatPercent(number, type) {
        if ((type === 'beta') || (type === 'sharpeRatio')) {
            return (number !== null ? parseFloat(number).toFixed(2) : '-');
        }
        if (type === 'drawdown') {
            return (number === null || isNaN(parseFloat(number)) ? '-' : `${parseFloat(number).toFixed(2)}%`);
        }
        return (number === null || isNaN(parseFloat(number)) ? '-' : `${parseFloat(number).toFixed(2)}%`);
    }

    formatDate(string) {
        return new Date(string).toLocaleDateString([], { timeZone: 'UTC' });
    }

    render() {
        const {value, index} = this.props;


        let endD = this.formatDate(value.endDate)
        let asOf = this.formatDate(value.asOfDate)
        let hideEndDate = (endD === asOf) ? 'yes' : 'no'

        return (<Fragment>
            <tr width='80' className='greyline' key={index}>
                <td className='textCenter'>
                    {this.formatDate(value.startDate)}
                </td>
                <td className='textCenter'>
                    {this.formatDate(value.endDate)}
                </td>
                <td className='textCenter'>
                    {value.numDrawDownDays}
                </td>
                <td className='textCenter'>
                    {this.formatPercent(value.drawDown, 'drawdown')}
                </td>
                {hideEndDate === 'no' &&
                    <td className='textCenter'>
                        {this.formatDate(value.recoveryDate)}
                    </td>
                }
                {hideEndDate === 'yes' &&
                    <td className='textCenter'>
                        N/A
                    </td>
                }
                {hideEndDate === 'no' &&
                    <td className='textCenter'>
                        {parseInt(value.recoveryDays, 10)}
                    </td>
                }
                {hideEndDate === 'yes' &&
                    <td className='textCenter'>
                        N/A
                    </td>
                }
            </tr>
        </Fragment>
        );
    }
}



function mapStateToProps(state) {
    return {
    };
}

export default connect(mapStateToProps, {})(DrawdownRow);
